import { render } from "./Employees.vue?vue&type=template&id=3475e4a9&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=ts"
export * from "./Employees.vue?vue&type=script&lang=ts"

import "./Employees.vue?vue&type=style&index=0&id=3475e4a9&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-3475e4a9"

export default script